module.exports = __webpack_public_path__ + "static/img/icon9.9cd09daf.svg";